<template>
  <div>
    <h3 class="text-paragraph text-theme" v-if="!isDialog">参考须知：</h3>
    <p class="text-paragraph text-indent text-bold text-theme">1、考试开放日期为每月{{examinationDay.join('/')}}号，其他时间暂不支持参加考试；</p>
    <p class="text-paragraph text-indent">2、每门课程不限制参考次数，考试通过则发放相应证书，如已获得同等级证书则不重复发放；如未通过，您可以前往微信端应用内相应课程的考试中心再次缴纳考试费用，即可获得考试机会；</p>
    <p class="text-paragraph text-indent">3、所有课程参考有效期为缴费日起180天，对于新报名的课程，有效期开始日为报名课程的时间；</p>
    <p class="text-paragraph text-indent">4、在您进入考试页面后不可随意退出当前考试页面，如退出则视为放弃考试机会，成绩作0分计算；</p>
    <p class="text-paragraph text-indent">5、考试过程中如检测到您登陆微信端应用，则认为您该次考试作弊，成绩作0分计算并自动结束考试；</p>
    <p class="text-paragraph text-indent">6、考试全程将通过您的浏览器进行拍摄与录音，同时不定时对考试页面进行静默巡查，巡查过程您不会有任何感知。请保证在考试期间不要离开考试页面，如果出现3次巡查失败将认定为作弊，考试成绩清零；</p>
    <p class="text-paragraph text-indent">7、对于不能进行拍摄和录音的浏览器，我们将拒绝您在该浏览器上进行考试，您可以使用别的支持拍摄和录音的浏览器或电脑设备参加考试；如果您的电脑支持拍摄和录音而浏览器不支持，建议您使用谷歌浏览器；</p>
    <p class="text-paragraph text-indent">8、考试过程中请勿手动关闭视频与音频的录制，否则将认为您该次考试作弊，成绩作0分计算并自动结束考试；</p>
    <p class="text-paragraph text-indent">9、考试过程中请保证电脑所处环境网络状况良好，如因您自身原因导致无法交卷或交卷失败，您需要自己承担相关责任；</p>
    <p class="text-paragraph text-indent">10、在您考试过程中录制的视频与录音文件仅作为考试作弊分析使用，如在视频与录音文件中发现作弊行为，我们会对您本次的成绩作0分处理，已发放的证书也将被撤销。</p>
    <p class="text-paragraph text-indent">11、由于不同课程具有不同的考试与证书发放规则，具体规则请见相应课程的详情介绍，或咨询我们的官方客服；如详情介绍中无特殊说明的，则使用第二条的证书发放规则。</p>
    <template v-if="browserSupportStatus === BROWSER_SUPPORT_STATUS.NOT_TEST">
      <p class="text-bold" v-if="!isDialog">点击下方按钮，立刻检测您当前使用的浏览器是否支持参加考试：</p>
      <p class="text-bold" v-else>点击下方按钮，立刻检测您当前使用的浏览器是否支持参加考试（如支持将直接开始考试）：</p>
      <Button class="margin-top-10px" type="primary" long @click="handleFunctionSupport" v-if="!isDialog">点击进行拍摄与录音检测</Button>
    </template>
    <template v-if="browserSupportStatus === BROWSER_SUPPORT_STATUS.NOT_SUPPORT">
      <Button type="error" long v-if="!isDialog">当前浏览器或电脑不支持参加考试</Button>
    </template>
    <template v-if="browserSupportStatus === BROWSER_SUPPORT_STATUS.SUPPORT">
      <Button type="success" long v-if="!isDialog">当前浏览器支持参加考试</Button>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { BROWSER_SUPPORT_STATUS } from '../libs/constant'
import { getFunctionSupport, sleep } from '../libs/util'

export default {
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      BROWSER_SUPPORT_STATUS
    }
  },
  computed: {
    ...mapState([ 'browserSupportStatus', 'examinationDay' ])
  },
  handlers: {
    async handleFunctionSupport (hideLoading = true, showSuccessNotice = true) {
      window.showLoading('正在检测您的浏览器...')
      const support = await getFunctionSupport()
      await sleep(2)
      this.setBrowserSupport(support)
      if (hideLoading) window.hideLoading(true)
      await sleep(0.5)
      if (support) {
        if (showSuccessNotice) {
          this.$Notice.success({
            title: '检测完成',
            desc: '您当前使用的浏览器或电脑符合参考要求，可以进行考试。'
          })
        }
      } else {
        this.$Notice.error({
          title: '当前浏览器或电脑不支持参加考试',
          desc: '您当前使用的浏览器或电脑由于不支持录制视频或音频，不符合参考设备要求，无法参加考试。您可以更换浏览器或电脑重新进行设备检测与考试。',
          duration: 10
        })
      }
      return support
    }
  },
  methods: {
    ...mapMutations([ 'setBrowserSupport' ]),

    async testBrowserSupport ({ hideLoading, showSuccessNotice }) {
      return await this.handleFunctionSupport(hideLoading, showSuccessNotice)
    }
  }
}
</script>

